import { createSvgComponent } from "../../icon/createSvgComponent";
import UserCircle from "@core/__generated__/icon/figma/user-circle.svg";
export default createSvgComponent(UserCircle);